export default __webpack_public_path__ + "static/media/CONE.637102bc.png";